export const MONTHS_GENITIVE = [
  "января",
  "февраля",
  "марта",
  "апреля",
  "мая",
  "июня",
  "июля",
  "августа",
  "сентября",
  "октября",
  "ноября",
  "декабря",
];

export const formatDate = (dateString: string) => {
  return new Date(dateString).toLocaleString("ru-RU", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatDateRange = (fromDate: string, toDate: string) => {
  const from = new Date(fromDate);
  const to = new Date(toDate);

  // Если одна дата
  if (fromDate === toDate) {
    const day = from.getDate();
    const month = MONTHS_GENITIVE[from.getMonth()];
    const year = from.getFullYear();
    return `${day} ${month} ${year}`;
  }

  const fromDay = from.getDate();
  const toDay = to.getDate();
  const fromMonth = from.getMonth();
  const toMonth = to.getMonth();
  const fromYear = from.getFullYear();
  const toYear = to.getFullYear();

  // Если одинаковый год и месяц
  if (fromYear === toYear && fromMonth === toMonth) {
    const month = MONTHS_GENITIVE[fromMonth];
    return `${fromDay} - ${toDay} ${month} ${fromYear}`;
  }

  // Если одинаковый год, но разные месяцы
  if (fromYear === toYear) {
    const fromMonthName = MONTHS_GENITIVE[fromMonth];
    const toMonthName = MONTHS_GENITIVE[toMonth];
    return `${fromDay} ${fromMonthName} - ${toDay} ${toMonthName} ${fromYear}`;
  }

  // Разные годы
  const fromMonthName = MONTHS_GENITIVE[fromMonth];
  const toMonthName = MONTHS_GENITIVE[toMonth];
  return `${fromDay} ${fromMonthName} ${fromYear} - ${toDay} ${toMonthName} ${toYear}`;
};
